import axios from 'axios'

export default {
  async getProvinceByZipcode(zipcode) {
    try {
      const response = await axios.get(`GetProvinceByZipcode/${zipcode}`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
